import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  Typography
} from '@mui/material';
import { api } from '../utils/api';

const labels = {
  PRELIEVO: {
    title: 'Prelievo cassa → cassaforte',
    helper: 'Contanti ritirati dal cassetto e depositati in cassaforte'
  },
  VERSAMENTO: {
    title: 'Versamento cassaforte → cassa',
    helper: 'Contanti prelevati dalla cassaforte e inseriti nel cassetto (es. prima di un pagamento in contanti)'
  }
};

const CashRegisterTransferDialog = ({ open, onClose, type, onSaved }) => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const config = labels[type] || labels.PRELIEVO;

  const handleClose = () => {
    setAmount('');
    setNote('');
    setError('');
    onClose();
  };

  const handleSave = async () => {
    const value = parseFloat(String(amount).replace(',', '.'));
    if (!Number.isFinite(value) || value <= 0) {
      setError('Inserisci un importo valido');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await api.post('/cash-register/transfers', {
        type,
        amount: value,
        note: note.trim() || undefined
      });
      if (onSaved) onSaved();
      handleClose();
    } catch (err) {
      setError(err.response?.data?.msg || 'Errore durante il salvataggio');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{config.title}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {config.helper}
        </Typography>
        <TextField
          label="Importo"
          type="number"
          fullWidth
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          inputProps={{ min: 0.01, step: '0.01' }}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Nota (opzionale)"
          fullWidth
          multiline
          minRows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>Annulla</Button>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? 'Salvataggio...' : 'Conferma'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CashRegisterTransferDialog;
